<template>
  <v-container fluid style="padding: 0 !important;">
    <p class="mb-3">{{ $t('yourTradingCommunitiesAcademies') }}</p>
    <v-row>
      <v-col lg="2" xl="2" class='pl-0'>
        <v-card class="adding-card-collapsed d-flex align-center justify-center" elevation="0" @click="findClub">
          <div class="d-flex justify-center align-center px-3">
            <v-icon class="plus-icon">fa-regular fa-search</v-icon>
            <p class="ml-2" style="font-size: 17px">{{ $t('findCommunity') }}</p>
          </div>
        </v-card>
      </v-col>
      <SingleCardAd v-if="ad !== null" :ad="ad"/>
      <v-col v-for="(club, index) in clubs" :key="club.id" cols="2" :class="(index == 5 ) ? 'pl-0' : (index == 4) ? 'pr-0' : ''">
        <v-card @mouseenter="hoverClub = club.id" @mouseleave="hoverClub = -1" class="overall-card-collapsed" outlined @click="clubSelection(club)">
          <!--v-card-title v-if="hoverClub === club.id" class="mt-n7 justify-end">
            <v-icon class="icon" color="secondary" @click="showDeleteClub(club)">fa-times-circle</v-icon>
          </v-card-title!-->
          <v-card-text class="pa-3 d-flex align-center" style="height: 100%">
            <v-avatar class="mr-2" size="42">
              <v-img :src="clubAvatarSrc(club)"></v-img>
            </v-avatar>
            <div>
              <v-chip x-small><p class="my-0" style="font-size: 14px;">{{ getRol(club.rol) }}</p></v-chip>
              <h3 class="head mt-1">{{ club.club.name }}</h3>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-overlay :dark="false" v-model="overlayFindClub">
      <FindClub :user-clubs="clubs" @closeWindow="overlayFindClub = false" @joinClub="joinClub"/>
    </v-overlay>
  </v-container>
</template>

<script>
import AdEngine from '../../ads/adEngine';

import Repository from '../../repositories/club';
import {mapMutations} from 'vuex';
import FindClub from "@/views/Community/components/FindClub";
import SingleCardAd from "@/ads/SingleCardAd";

const CLUB_DEFAULT_AVATAR_URL =
  'https://swiset-public-multimedia.s3.us-east-1.amazonaws.com/1777038643657-0bd4e988-1a5d-488c-88bf-8c8ea376dba1.webp'

export default {
  name: "ClubModule",
  components: {SingleCardAd, FindClub},
  data() {
    return {
      // Ads
      ad: null,

      selectedClub: null,
      overlayDeleteClubRequest: false,
      hoverClub: -1,
      overlayFindClub: false,
      clubs: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    retrieveAd() {
      this.ad = AdEngine.getRandomAd('Small Ad');
    },
    init() {
      this.retrieveAd();
      Repository.allClubsOfUser().then((response) => {
        if (response.status < 400) {
          this.clubs = response.data;
        }
      });
    },
    getRol(rol) {
      return (rol === 'FOUNDER')? this.$t('roles.founder') :
          (rol === 'ADMIN')? this.$t('roles.admin') :
              (rol === 'MEMBER')? this.$t('roles.member') : this.$t('roles.pending');
    },
    clubAvatarSrc(club) {
      const url = club && club.club && club.club.imageUrl
      if (url && String(url).trim()) {
        return String(url).trim()
      }
      return CLUB_DEFAULT_AVATAR_URL
    },
    findClub() {
      this.overlayFindClub = true;
    },
    ...mapMutations(['setClubMember']),
    clubSelection(club) {
      if (club.rol !== 'PENDING') {
        this.setClubMember(club);
        this.$router.push('/club');
      } else
        alert(this.$t('requestNotApproved', {name: club.club.name}));
    },
    joinClub() {
      Repository.allClubsOfUser().then((response) => {
        if (response.status < 400) {
          this.clubs = response.data;
        }
      });
    },
    showDeleteClubRequest(club) {
      this.selectedClub = club;
      this.overlayDeleteClubRequest = true;
    },
    clubOptions(club) {
      // eslint-disable-next-line no-console
      console.log(club);
    },
    capitalize(string) {
      return string[0] + string.slice(1).toLowerCase();
    },
    truncateString(string) {
      return (string !== null && string.length > 70) ? `${string.substring(0, 70)}...` : string;
    },
  }
}
</script>

<style scoped>

</style>


